import React from 'react';
import ScrollAnimation from './ScrollAnimation';

const About = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-amber-50 via-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <ScrollAnimation animation="fadeInUp">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-amber-900 mb-8">
              אודות מצבעת המומחים
            </h2>
            <div className="w-32 h-1 bg-gradient-to-r from-amber-400 to-amber-600 mx-auto mb-10 rounded-full"></div>
            <p className="text-2xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-light">
              כבר מעל 15 שנה אנו מתמחים בהפיכת רהיטים ישנים לחתיכות אמנות מרהיבות
            </p>
          </div>
        </ScrollAnimation>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <ScrollAnimation animation="fadeInRight">
            <div className="space-y-8">
              <div className="space-y-6">
                <h3 className="text-3xl font-bold text-amber-900">הסיפור שלנו</h3>
                <p className="text-xl text-gray-700 leading-relaxed">
                  מצבעת המומחים נוסדה מתוך אהבה אמיתית לעבודת יד איכותית ורצון להעניק חיים חדשים לרהיטים ישנים. 
                  מה שהתחיל כתחביב הפך לעסק משפחתי מצליח שמשרת מאות לקוחות מרוצים.
                </p>
                <p className="text-xl text-gray-700 leading-relaxed">
                  אנו מאמינים שלכל רהיט יש נשמה וסיפור. התפקיד שלנו הוא לחשוף את היופי הטמון בו ולספר את הסיפור מחדש. 
                  עם שימוש בטכניקות מתקדמות, חומרים איכותיים ותשומת לב מקסימלית לפרטים.
                </p>
              </div>

              <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-xl">
                <h4 className="text-2xl font-bold text-amber-900 mb-6">למה לבחור בנו?</h4>
                <ul className="space-y-4">
                  <li className="flex items-center space-x-3 space-x-reverse">
                    <div className="w-2 h-2 bg-amber-600 rounded-full ml-2"></div>
                    <span className="text-lg text-gray-700">ניסיון מעל 15 שנה בתחום</span>
                  </li>
                  <li className="flex items-center space-x-3 space-x-reverse">
                    <div className="w-2 h-2 bg-amber-600 rounded-full ml-2"></div>
                    <span className="text-lg text-gray-700">שימוש בחומרים איכותיים ביותר</span>
                  </li>
                  <li className="flex items-center space-x-3 space-x-reverse">
                    <div className="w-2 h-2 bg-amber-600 rounded-full ml-2"></div>
                    <span className="text-lg text-gray-700">התאמה אישית לכל לקוח</span>
                  </li>
                  <li className="flex items-center space-x-3 space-x-reverse">
                    <div className="w-2 h-2 bg-amber-600 rounded-full ml-2"></div>
                    <span className="text-lg text-gray-700">אחריות מלאה על העבודה</span>
                  </li>
                </ul>
              </div>
            </div>
          </ScrollAnimation>

          <ScrollAnimation animation="fadeInLeft" delay={200}>
            <div className="relative">
              <div className="grid grid-cols-2 gap-6">
                <div className="space-y-6">
                  <img 
                    src="https://images.unsplash.com/photo-1712171984530-e25a4aaa46dd" 
                    alt="אמן צובע ומחדש רהיט עץ בחומרי איכות - דוגמה לעבודה מקצועית באיכות גבוהה"
                    className="rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300"
                  />
                  <img 
                    src="https://images.unsplash.com/photo-1618588291966-fd658dab68a8" 
                    alt="פרטי עבודה מקצועית - כלי עבודה וטכניקות צביעה מתקדמות לשיפוץ רהיטים"
                    className="rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300"
                  />
                </div>
                <div className="space-y-6 mt-12">
                  <img 
                    src="https://images.unsplash.com/photo-1532588213355-52317771cce6" 
                    alt="רהיט עץ מחודש ומשופץ - תוצאה מרשימה של עבודת צביעה וגימור מקצועית"
                    className="rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300"
                  />
                  <img 
                    src="https://images.unsplash.com/photo-1642030046046-4147729c9b40" 
                    alt="תוצאה סופית מרשימה - רהיט משופץ ומחודש עם גימור איכותי וצביעה מושלמת"
                    className="rounded-2xl shadow-xl hover:shadow-2xl transition-shadow duration-300"
                  />
                </div>
              </div>
              {/* Decorative elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-amber-200/30 rounded-full blur-xl"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-orange-200/30 rounded-full blur-xl"></div>
            </div>
          </ScrollAnimation>
        </div>

      </div>
    </section>
  );
};

export default About;